export class AddTransactionsPayload {
  transactionIds: number[];
}
